module.exports = __webpack_public_path__ + "img/question-circle-white.d377efb3.svg";